import { defineMessages } from 'react-intl';

export default defineMessages({
    uwIssueTitle: {
        "id": "twia.uwIssues.view.Underwriting issues have been raised for this quote:",
        "defaultMessage": "Underwriting issues have been raised for this quote:"
    },
    uwIssuePolicyChangeTitle: {
        "id": "twia.uwIssues.pc.view.Underwriting issues have been raised for this quote:",
        "defaultMessage": "Underwriting issues have been raised for this Policy Change:"
    },
    youCanStaticText: {
        "id": "twia.uwIssues.view.You can do the following:",
        "defaultMessage": "You can do the following:"
    },
    editQuote: {
        "id": "twia.uwIssues.view.Edit the quote",
        "defaultMessage": "Edit the quote",
    },
    editPolicyChange: {
        "id": "twia.uwIssues.pc.view.Edit the quote",
        "defaultMessage": "Edit the Policy Change",
    },
    referToUnderwriter: {
        "id": "twia.uwIssues.view.Refer the quote to the underwriter",
        "defaultMessage": "Refer the quote to the underwriter",
    },
    referToUnderwriterChange: {
        "id": "twia.uwIssues.view.Refer the Policy Change to the underwriter",
        "defaultMessage": "Refer the Policy Change to the underwriter",
    },
    withdrawQuote: {
        "id": "twia.uwIssues.view.Withdraw the quote",
        "defaultMessage": "Withdraw the quote"
    },
    withdrawPolicyChange: {
        "id": "twia.uwIssues.pc.view.Withdraw the quote",
        "defaultMessage": "Withdraw the Policy Change"
    },
    withdrawPolicyChangePopup: {
        "id": "twia.uwIssues.pc.view.Withdraw Policy Change?",
        "defaultMessage": "Withdraw Policy Change?"
    },
    uwIssues: {
        "id": "twia.uwIssues.view.Underwriting Issues:",
        "defaultMessage": "Underwriting Issues:"
    },
    tableHeaderPostalCode: {
        "id": "twia.addressStandardization.pickList.view.Postal COde",
        "defaultMessage": "POSTAL CODE"
    },
    withdrawButton: {
        "id": "twia.uwIssues.view.Withdraw Quote",
        "defaultMessage": "Withdraw Quote"
    },
    referToUnderwriterButton: {
        "id": "twia.uwIssues.view.Refer to Underwriter",
        "defaultMessage": "Refer to Underwriter"
    },
    referToUnderwriterTitle: {
        "id": "twia.uwIssues.view.Refer to Underwriter",
        "defaultMessage": "Refer to Underwriter"
    },
    noteReferToUnderwriter: {
        "id": "twia.uwIssues.view.Note for Underwriter (optional)",
        "defaultMessage": "Note for Underwriter (optional)"
    },
    onceReferred: {
        "id": "twia.uwIssues.view.Once referred, a high priority activity will be created for the underwriter. You will not be able to edit the quote until the underwriter releases it back to you.",
        "defaultMessage": "Once referred, a high priority activity will be created for the underwriter. You will not be able to edit the quote until the underwriter releases it back to you."
    },
    onceReferredChange: {
        "id": "twia.uwIssues.view.Once referred, a high priority activity will be created for the underwriter. You will not be able to edit the Policy Change until the underwriter releases it back to you.",
        "defaultMessage": "Once referred, a high priority activity will be created for the underwriter. You will not be able to edit the policy change until the underwriter releases it back to you."
    },
    confirmMessage: {
        "id": "twia.uwIssues.view.Are you sure you want to refer this quote to the underwriter?",
        "defaultMessage": "Are you sure you want to refer this quote to the underwriter?"
    },
    withDrawJOB: {
        id: 'twia.uwIssues.view.Withdraw',
        defaultMessage: 'Withdraw the quote',
    },
    sureWithDrawQuote: {
        id: 'twia.uwIssues.view.Are you sure you want to withdraw quote:',
        defaultMessage: 'Are you sure you want to withdraw quote:',
    },
    sureWithDrawPolicyChange: {
        id: 'twia.uwIssues.view.Are you sure you want to withdraw Policy Change:',
        defaultMessage: 'Are you sure you want to withdraw policy change:',
    },
    withdraw: {
        id: 'twia.uwIssues.view.withdrawPopUp',
        defaultMessage: 'Withdraw',
    },
    failedWithdrawSubmission: {
        id: 'twia.uwIssues.view.Failed to withdraw submission',
        defaultMessage: 'Failed to withdraw submission',
    },
    cancelWithdrawSubmission: {
        id: 'twia.uwIssues.view.Cancel ',
        defaultMessage: 'Cancel ',
    },
    uwPolicyHold_twia: {
        id: 'twia.uwIssues.view.You may complete and submit the quote after the moratorium has been lifted.',
        defaultMessage: 'You may complete and submit the quote after the moratorium has been lifted.',
    },
    TWIAWizardModalCancelTitle: {
        id: 'twia.uwIssues.view.residential.TWIA.Modal.Cancel title',
        defaultMessage: 'Are you sure you want to exit?',
    },
    TWIAWizardModalCancelDescription: {
        id: 'twia.uwIssues.view.residential.TWIA.Modal.Cancel description',
        defaultMessage: 'The information you entered will be stored as a draft quote. You must complete and submit this quote within 30 days of its Effective Date, or it will expire.',
    },
    referToUWSubmission: {
        id: 'gateway.views.job-uwissues.Are you sure you want to refer this quote to the Underwriter?',
        defaultMessage:
            'Are you sure you want to refer this quote to the Underwriter?',
    },
    referToUWPolicyChange: {
        id: 'gateway.views.job-uwissues.Are you sure you want to refer this policy change to the Underwriter?',
        defaultMessage:
            'Are you sure you want to refer this policy change to the Underwriter?',
    },
    uwIssuePolicyChangeTFPA: {
        id: "twia.uwIssues.pc.view.There are underwriting issues associated with this offering. Click here to view more details.",
        defaultMessage: "There are underwriting issues associated with this offering. "
    },
    uwIssuePolicyChangeTFPAContinued: {
        id: "twia.uwIssues.pc.view.to view more details.",
        defaultMessage: "to view more details."
    },
})